import { Operator } from './types';

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [
    { value: 10, label: '10 resources' },
    { value: 25, label: '25 resources' },
    { value: 50, label: '50 resources' },
    { value: 100, label: '100 resources' },
    { value: 500, label: '500 resources' },
    { value: 1000, label: '1000 resources' },
    { value: Number.MAX_SAFE_INTEGER, label: 'All'},
];

export const localization = {
    PREFERENCE_HEADER: 'Preferences',
    CONFIRM_BUTTON_TEXT: 'Confirm',
    CANCEL_BUTTON_TEXT: 'Cancel',
    DOWNLOAD_BUTTON_TEXT: 'Download',
    PAGE_SIZE_HEADER: 'Page size',
    VISIBLE_COLUMN_HEADER: 'Select visible columns',
    WRAP_LINE_LABEL: 'Wrap lines',
    WRAP_LINE_DESCRIPTION: 'Check to see all the text and wrap the lines',
    LOADING: 'Loading',
    NO_MATCH_TITLE: 'No matches',
    NO_MATCH_CONTENT: 'We can\'t find a match.',
    NO_MATCH_ACTION: 'Clear filter',
    DOWNLOAD_TITLE: 'Download CSV',
    DOWNLOAD_ALL: 'All data',
    DOWNLOAD_ALL_DESCRIPTION: 'Export all records',
    DOWNLOAD_FILE_CSV_EXTENSION: '.csv',
    DOWNLOAD_FILE_NAME: 'table',
    DOWNLOAD_FILTERED: 'Filtered Data',
    DOWNLOAD_FILTERED_DESCRIPTION: 'Export only those records that match the current filters',
    DOWNLOAD_SELECTED_DESCRIPTION: 'Export only the selected records',
    DOWNLOAD_SINGLE_PAGE: 'Single page',
    DOWNLOAD_SINGLE_PAGE_DESCRIPTION: 'Export all the records on the current page only',
    DOWNLOAD_XSLX: 'Download XLSX',
};
export const PROPERTY_FILTERING_I18N_CONSTANTS = {
    filteringAriaLabel: 'your choice',
    dismissAriaLabel: 'Dismiss',
  
    filteringPlaceholder: 'Search',
    groupValuesText: 'Values',
    groupPropertiesText: 'Properties',
    operatorsText: 'Operators',
  
    operationAndText: 'and',
    operationOrText: 'or',
  
    operatorLessText: 'Less than',
    operatorLessOrEqualText: 'Less than or equal',
    operatorGreaterText: 'Greater than',
    operatorGreaterOrEqualText: 'Greater than or equal',
    operatorContainsText: 'Contains',
    operatorDoesNotContainText: 'Does not contain',
    operatorEqualsText: 'Equals',
    operatorDoesNotEqualText: 'Does not equal',
  
    editTokenHeader: 'Edit filter',
    propertyText: 'Property',
    operatorText: 'Operator',
    valueText: 'Value',
    cancelActionText: 'Cancel',
    applyActionText: 'Apply',
    allPropertiesLabel: 'All properties',
  
    tokenLimitShowMore: 'Show more',
    tokenLimitShowFewer: 'Show fewer',
    clearFiltersText: 'Clear filters',
    removeTokenButtonAriaLabel: () => 'Remove token',
    enteredTextLabel: (text: string) => `Use: "${text}"`,
};

export const paginationLabels = {
    nextPageLabel: 'Next page',
    previousPageLabel: 'Previous page',
    pageLabel: (pageNumber: number): string => `Page ${pageNumber} of all pages`
};

export const nonNumericOperators: Operator[] = [':', '!:', '=', '!='];
export const numericOperators: Operator[] = ['<', '<=', '>', '>=', ':', '!:', '=', '!='];
